var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgExternalLink = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.75 2.25C15.75 2.66421 16.0858 3 16.5 3H19.9393L9.21967 13.7197C8.92678 14.0126 8.92678 14.4874 9.21967 14.7803C9.51256 15.0732 9.98744 15.0732 10.2803 14.7803L21 4.06066V7.5C21 7.91421 21.3358 8.25 21.75 8.25C22.1642 8.25 22.5 7.91421 22.5 7.5V2.25C22.5 1.83579 22.1642 1.5 21.75 1.5H16.5C16.0858 1.5 15.75 1.83579 15.75 2.25ZM9 6C9.41421 6 9.75 5.66421 9.75 5.25C9.75 4.83579 9.41421 4.5 9 4.5H4.25C3.52066 4.5 2.82118 4.78973 2.30546 5.30546C1.78973 5.82118 1.5 6.52065 1.5 7.25V12V19.75C1.5 20.4793 1.78973 21.1788 2.30546 21.6945C2.82118 22.2103 3.52065 22.5 4.25 22.5H12H16.75C17.4793 22.5 18.1788 22.2103 18.6945 21.6945C19.2103 21.1788 19.5 20.4793 19.5 19.75V15C19.5 14.5858 19.1642 14.25 18.75 14.25C18.3358 14.25 18 14.5858 18 15V19.75C18 20.0815 17.8683 20.3995 17.6339 20.6339C17.3995 20.8683 17.0815 21 16.75 21H12H4.25C3.91848 21 3.60054 20.8683 3.36612 20.6339C3.1317 20.3995 3 20.0815 3 19.75L3 11.9992L3 7.25C3 6.91848 3.1317 6.60054 3.36612 6.36612C3.60054 6.1317 3.91848 6 4.25 6H9Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgExternalLink);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/external-link.7ee9b6c0dded2bca7817d488e7c94a49.svg";